import { useState } from "react"

export default function UserManual({ closeUserManual }) {
  const [zoomImgSrc, setZoomImgSrc] = useState(null)

  const handleImageClick = (src) => {
    setZoomImgSrc(src)
  }

  const closeZoom = () => {
    setZoomImgSrc(null)
  }

  return (
    <>
      <div className="fgh-user-manual-container">
        <div className="fgh-usermanual-content">
          <h2 className="fgh-user-manual-title">User Manual</h2>
          <h2 className="fgh-h2-style">Account Management</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Sign-up & Login: </strong> Via
                the "Login/Register" button fill in your details to register or
                enter credentials to log in.
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-MANUAL_NEW_LOGIN.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-MANUAL_NEW_LOGIN.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER_MANUAL_LOGIN_MOBILE_NEW.webp"
                    alt="Login Screenshot Mobile"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER_MANUAL_LOGIN_MOBILE_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
              <li>
                <strong className="user-guide"> Password & PIN: </strong> Change
                your password or withdrawal PIN from{" "}
                <strong className="user-guide"> Profile → </strong>
                <strong className="user-guide">
                  {" "}
                  <a href="/profile#security">Account Security.</a>{" "}
                </strong>{" "}
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-MANUAL_PASSWORD_AND_PIN.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-MANUAL_PASSWORD_AND_PIN.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER_MANUAL_PASSWORD_MOBILE.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER_MANUAL_PASSWORD_MOBILE.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Getting Started & Playing</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Launch Games: </strong> Pick
                Slots, Live Dealers, or Sportsbook from the left menu, then
                select a provider or use filters.{" "}
              </li>
              <li>
                <strong className="user-guide"> Browse & Search: </strong> "Top
                Games Today" carousel for popular slots, use the search icon to
                find any game or provider.{" "}
              </li>
              <li>
                <strong className="user-guide">Search for a Game: </strong>
                Click the search icon, type a game or provider name.
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-MANUAL_GAMES_NEW.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-MANUAL_GAMES_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER_MANUAL_GAME_MOBILE_NEW.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER_MANUAL_GAME_MOBILE_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Navigating to the Slots Page</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Browsing Slot Games: </strong>{" "}
                The slot page features a wide range of games from top providers
                such as:{" "}
                <strong className="user-guide">
                  {" "}
                  JILI, YGG, BNG, BETSOFT{" "}
                </strong>
                etc. You can scroll down to explore or use filters for faster
                access.
              </li>
              <li>
                <strong className="user-guide">
                  {" "}
                  Game Provider Dropdown:{" "}
                </strong>{" "}
                Click on the dropdown beside the filter icon and select your
                preferred provider like{" "}
                <strong className="user-guide">
                  JILI, RTG, or POPOK.{" "}
                </strong>{" "}
              </li>
              <li>
                Click the <strong className="user-guide">View All</strong>{" "}
                button to see the full list of available providers.
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-MANUAL_SLOTS_NEW.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_SLOTS_NEW.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_SLOTS_MOBILE_NEW.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_SLOTS_MOBILE_NEW.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <li>
                <strong className="user-guide"> Playing a Slot Game: </strong>{" "}
                Click on any game thumbnail (e.g. 10,001 Nights, 2 Million B.C).
                The game will load in a new window or tab.
              </li>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Promotions</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                Find All active offers under{" "}
                <strong className="user-guide">
                  <a href="/promotion">Promotions</a>{" "}
                </strong>{" "}
                in the left menu, filter by frequency
                <strong className="user-guide">
                  {" "}
                  (Daily/Weekly/Monthly/All)
                </strong>
                , and click "Details" to see full content.
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-MANUAL_PROMOTION_NEW.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-MANUAL_PROMOTION_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER_MANUAL_PROMOTIONS_MOBILE_NEW.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER_MANUAL_PROMOTIONS_MOBILE_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Account Binding</h2>
          <ul className="fgh-paragraph-standard-style">
            <div>
              <li>
                <strong className="user-guide"> Cash out: </strong> Click Add
                Payment Method → Choose Payment Method → Add Personal Details →
                Sent OTP to successfully register number{" "}
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-ACCOUNT_PAYMENT_METHOD.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-ACCOUNT_PAYMENT_METHOD.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-ACCOUNT_BINDING.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-ACCOUNT_BINDING.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER-ACCOUNT_PAYMENT_METHOD_MOBILE.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-ACCOUNT_PAYMENT_METHOD_MOBILE.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                  <img
                    src="/images/user-manual/USER-ACCOUNT_BINDING_MOBILE.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-ACCOUNT_BINDING_MOBILE.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
            </div>
          </ul>
          <h2 className="fgh-h2-style">Wallet (Cash In / Cash Out)</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Deposit: </strong> Click the
                Wallet icon → Cash In → Choose method & amount → Continue Cash
                In.{" "}
                <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                  <img
                    src="/images/user-manual/USER-MANUAL_DEPOSIT.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER-MANUAL_DEPOSIT.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
                <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                  <img
                    src="/images/user-manual/USER_MANUAL_CASHINOUT_MOBILE_NEW.webp"
                    alt="Login Screenshot"
                    onClick={() =>
                      handleImageClick(
                        "/images/user-manual/USER_MANUAL_CASHINOUT_MOBILE_NEW.webp"
                      )
                    }
                    style={{
                      cursor: "zoom-in",
                    }}
                  />
                </div>
              </li>
              <li>
                <strong className="user-guide"> Withdraw: </strong> Go to Wallet
                → Cash Out → Select Linked Account → Enter Amount → Continue
                Cashout.{" "}
                <ul>
                  <li style={{ listStyleType: "none", paddingBottom: "10px" }}>
                    <strong className="user-guide">Note:</strong> Please add
                    your account first before proceeding with cash out.
                  </li>
                </ul>
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-ACCOUNT_SELECT_METHOD.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-ACCOUNT_SELECT_METHOD.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_CASHINOUT_MOBILE_CHOOSE_ACC.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_CASHINOUT_MOBILE_CHOOSE_ACC.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <li>
                <strong className="user-guide"> History: </strong> View or
                cancel pending requests in{" "}
                <strong className="user-guide"> Wallet → </strong>{" "}
                <strong className="user-guide"> Transaction History.</strong>
              </li>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Support & Help</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Live Chat: </strong> 24/7 via
                the on-site widget.{" "}
              </li>
              <li>
                <strong className="user-guide"> Phone: </strong>{" "}
                +63-2-8-62632222{" "}
              </li>
              <li>
                <strong className="user-guide"> Email: </strong> support@fgh.fun
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-MANUAL_SUPPORT_NEW.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_SUPPORT_NEW.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER-MANUAL_SUPPORT_MOBILE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_SUPPORT_MOBILE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
            </p>
          </ul>
          <h2 className="fgh-h2-style"> Contact Us </h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Phone: </strong> +63-2-8-6263222
              </li>
              <li>
                <strong className="user-guide"> Viber: </strong>{" "}
                +855-969-845-661
              </li>
              {/* <li>
                <strong className="user-guide"> Whatsapp: </strong> FUN GAMING
                HUB
              </li> */}
              <li>
                <strong className="user-guide"> Telegram: </strong>{" "}
                @FUNGAMINGHUB
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER_MANUAL_CONTACT_SOCIAL_NEW.webp"
                  alt="Contact Us"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_CONTACT_SOCIAL_NEW.webp"
                    )
                  }
                  style={{ cursor: "zoom-in" }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_CONTACT_SOCIAL_MOBILE.webp"
                  alt="Contact Us"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_CONTACT_SOCIAL_MOBILE.webp"
                    )
                  }
                  style={{ cursor: "zoom-in" }}
                />
              </div>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Mobile App</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                Install via{" "}
                <strong className="user-guide">
                  {" "}
                  <a href="/android">Download App</a>{" "}
                </strong>{" "}
                in the menu or footer (scan the QR code or tap the Android
                link).{" "}
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-MANUAL_ANDROID.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_ANDROID.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_APP_MOBILE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_APP_MOBILE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Profile & Reports</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Activity: </strong> Check
                turnover and win/loss by date range under{" "}
                <strong className="user-guide"> Profile → </strong>
                <strong className="user-guide"> Activity. </strong>{" "}
              </li>
              <li>
                <strong className="user-guide"> VIP: </strong> Track your tier
                and rewards in the{" "}
                <strong className="user-guide"> VIP Level </strong> and{" "}
                <strong className="user-guide"> VIP </strong> sections.{" "}
              </li>
              <li>
                <strong className="user-guide"> Referrals: </strong> Copy your
                referral link/QR code from{" "}
                <strong className="user-guide"> Profile → </strong>
                <strong className="user-guide"> Referral Status. </strong>
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-MANUAL_PROFILE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_PROFILE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_PROFILE_MOBILE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_PROFILE_MOBILE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
            </p>
          </ul>
          <h2 className="fgh-h2-style">Sharing & Commissions</h2>
          <ul>
            <p className="fgh-paragraph-standard-style">
              <li>
                <strong className="user-guide"> Share Credits: </strong> Send or
                accept credits via{" "}
                <strong className="user-guide"> Profile → </strong>
                <strong className="user-guide">
                  {" "}
                  <a href="/profile#credits">Share Credits</a>,{" "}
                </strong>{" "}
                then track in the Report tab.
              </li>
              <li>
                <strong className="user-guide"> Rolling Commission: </strong>{" "}
                View your earnings under the rolling commission icon.{" "}
              </li>
              <div className="fgh-user-guide-photo fgh-user-guide-desktop">
                <img
                  src="/images/user-manual/USER-MANUAL_SHARE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER-MANUAL_SHARE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <div className="fgh-user-guide-photo fgh-user-guide-mobile">
                <img
                  src="/images/user-manual/USER_MANUAL_SHARE_MOBILE.webp"
                  alt="Login Screenshot"
                  onClick={() =>
                    handleImageClick(
                      "/images/user-manual/USER_MANUAL_SHARE_MOBILE.webp"
                    )
                  }
                  style={{
                    cursor: "zoom-in",
                  }}
                />
              </div>
              <li>
                <strong className="user-guide"> VIP Commission Promo: </strong>{" "}
                Details in <strong className="user-guide"> Promotions </strong>{" "}
                under "FGH Exclusive VIP Rolling Commission."
              </li>
            </p>
          </ul>
        </div>
        <div
          className="fgh-user-manual-close"
          onClick={closeUserManual}
          style={{ cursor: "pointer" }}
        >
          <p>CLOSE</p>
        </div>

        {zoomImgSrc && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
            onClick={closeZoom}
          >
            <img
              className="zoomed-image"
              src={zoomImgSrc}
              alt="Zoomed"
              style={{
                maxHeight: "90%",
                // boxShadow: "0 0 10px rgba(255,255,255,0.3)",
              }}
            />
          </div>
        )}
      </div>
    </>
  )
}
